module.exports = {"321111001":"宝塔路街道","321111002":"和平路街道","321111003":"金山街道","321111004":"七里甸街道","321111005":"蒋乔街道","321111006":"官塘桥街道","321111007":"韦岗街道","321111008":"南山街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321111.json
// module id = 922
// module chunks = 0